import { render, staticRenderFns } from "./OpExchangePanel.vue?vue&type=template&id=d342edb8&"
import script from "./OpExchangePanel.vue?vue&type=script&lang=ts&"
export * from "./OpExchangePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports